@if (country && localizationInfo) {
  <div class="container-fluid">
    <div class="row row-padding">
      <div class="col">
        <app-vendor-address-edit
          [VendorId]="VendorId"
          [streetAddressForm]="streetAddressForm"
          [mailingAddressForm]="mailingAddressForm"
          [remitToAddressForm]="remitToAddressForm"
          [country]="country"
          [localizationInfo]="localizationInfo"
        ></app-vendor-address-edit>
      </div>
    </div>
    <div class="row row-padding">
      <div class="col">
        <button class="btn btn-secondary" (click)="close()">Cancel</button>
      </div>
      <div class="col">
        <button class="btn btn-primary" (click)="confirm()">Confirm</button>
      </div>
    </div>
  </div>
}
